var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.39058C2.25 6.62258 2.87258 6 3.64058 6V6C4.16729 6 4.64879 5.70241 4.88435 5.23131L5.5 4C5.80643 3.38713 6.43283 3 7.11803 3H10.882C11.5672 3 12.1936 3.38713 12.5 4L13.1157 5.23131C13.3512 5.70241 13.8327 6 14.3594 6V6C15.1274 6 15.75 6.62258 15.75 7.39058V11.1429C15.75 11.9396 15.75 12.338 15.6748 12.6676C15.4184 13.7911 14.5411 14.6684 13.4176 14.9248C13.088 15 12.6896 15 11.8929 15H6.10714C5.31037 15 4.91198 15 4.58244 14.9248C3.45895 14.6684 2.58164 13.7911 2.32522 12.6676C2.25 12.338 2.25 11.9396 2.25 11.1429V7.39058Z",
    stroke: "#20212C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.75,
    r: 2.5,
    stroke: "#20212C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.f7c01718d2487d610dfe9f04ec106273.svg";
export { ForwardRef as ReactComponent };